var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpriteIcons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "fileDownload_solid_blue",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_820_57220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.0213 12.6667C8.28403 12.6671 8.54427 12.6156 8.78704 12.5152C9.02982 12.4147 9.25035 12.2673 9.43596 12.0813L12.0486 9.46667L11.106 8.52667L8.68396 10.9493L8.66663 0H7.3333L7.35063 10.9387L4.9373 8.52533L3.99463 9.46667L6.6073 12.0793C6.79268 12.2655 7.01304 12.4133 7.2557 12.5141C7.49835 12.6149 7.75854 12.6667 8.0213 12.6667V12.6667Z",
    fill: "#005c8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 10.667V14.0003C14.6667 14.1771 14.5964 14.3467 14.4714 14.4717C14.3464 14.5967 14.1768 14.667 14 14.667H2C1.82319 14.667 1.65362 14.5967 1.5286 14.4717C1.40357 14.3467 1.33333 14.1771 1.33333 14.0003V10.667H0V14.0003C0 14.5308 0.210714 15.0395 0.585786 15.4145C0.960859 15.7896 1.46957 16.0003 2 16.0003H14C14.5304 16.0003 15.0391 15.7896 15.4142 15.4145C15.7893 15.0395 16 14.5308 16 14.0003V10.667H14.6667Z",
    fill: "#005c8a"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_820_57220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "add-cell1",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M455.1,0H56.9C25.5,0,0,25.5,0,56.9v398.2C0,486.5,25.5,512,56.9,512h398.2c31.4,0,56.9-25.5,56.9-56.9V56.9C512,25.5,486.5,0,455.1,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M455.1,0H56.9C25.5,0,0,25.5,0,56.9v398.2C0,486.5,25.5,512,56.9,512h398.2c31.4,0,56.9-25.5,56.9-56.9V56.9C512,25.5,486.5,0,455.1,0z M160,448H64v-96h96V448z M160,320H64V192h96V320z M160,160H64V64h96V160z M320,448H192v-96h128V448z M320,160H192V64h128V160z M448,448h-96v-96h96V448z M448,320h-96V192h96V320z M448,160h-96V64h96V160z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "fileUpload_solid_blue",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_820_56484)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.0213 3.33333C8.28403 3.33289 8.54427 3.38437 8.78704 3.48482C9.02982 3.58527 9.25035 3.73271 9.43596 3.91867L12.0486 6.53333L11.106 7.47333L8.68396 5.05067L8.66663 16H7.3333L7.35063 5.06133L4.9373 7.47467L3.99463 6.53333L6.6073 3.92067C6.79269 3.73446 7.01304 3.58672 7.2557 3.48592C7.49835 3.38513 7.75854 3.33327 8.0213 3.33333Z",
    fill: "#005c8a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 5.33301V1.99968C14.6667 1.82287 14.5964 1.6533 14.4714 1.52828C14.3464 1.40325 14.1768 1.33302 14 1.33302H2C1.82319 1.33302 1.65362 1.40325 1.5286 1.52828C1.40357 1.6533 1.33333 1.82287 1.33333 1.99968V5.33301H0V1.99968C0 1.46925 0.210714 0.960542 0.585786 0.585469C0.960859 0.210397 1.46957 -0.000315666 2 -0.000315666H14C14.5304 -0.000315666 15.0391 0.210397 15.4142 0.585469C15.7893 0.960542 16 1.46925 16 1.99968V5.33301H14.6667Z",
    fill: "#005c8a"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_820_56484"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 16)"
  }))))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "pencil_fill_blue",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7279 9.57629L14.3137 8.16207L5 17.4758V18.89H6.41421L15.7279 9.57629ZM17.1421 8.16207L18.5563 6.74786L17.1421 5.33365L15.7279 6.74786L17.1421 8.16207ZM7.24264 20.89H3V16.6474L16.435 3.21233C16.8256 2.8218 17.4587 2.8218 17.8492 3.21233L20.6777 6.04075C21.0682 6.43128 21.0682 7.06444 20.6777 7.45497L7.24264 20.89Z",
    fill: "rgba(0,92,138,1)"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "delete_fill_blue",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z",
    fill: "rgba(0,92,138,1)"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "money_solid_blue",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: 18,
    height: 18
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3227_12000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 3H2.25C1.65326 3 1.08097 3.23705 0.65901 3.65901C0.237053 4.08097 0 4.65326 0 5.25L0 15H18V5.25C18 4.65326 17.7629 4.08097 17.341 3.65901C16.919 3.23705 16.3467 3 15.75 3ZM16.5 13.5H1.5V5.25C1.5 5.05109 1.57902 4.86032 1.71967 4.71967C1.86032 4.57902 2.05109 4.5 2.25 4.5H15.75C15.9489 4.5 16.1397 4.57902 16.2803 4.71967C16.421 4.86032 16.5 5.05109 16.5 5.25V13.5ZM9 6C8.40666 6 7.82664 6.17595 7.33329 6.50559C6.83994 6.83524 6.45542 7.30377 6.22836 7.85195C6.0013 8.40013 5.94189 9.00333 6.05764 9.58527C6.1734 10.1672 6.45912 10.7018 6.87868 11.1213C7.29824 11.5409 7.83279 11.8266 8.41473 11.9424C8.99667 12.0581 9.59987 11.9987 10.1481 11.7716C10.6962 11.5446 11.1648 11.1601 11.4944 10.6667C11.8241 10.1734 12 9.59334 12 9C12 8.20435 11.6839 7.44129 11.1213 6.87868C10.5587 6.31607 9.79565 6 9 6ZM9 10.5C8.70333 10.5 8.41332 10.412 8.16665 10.2472C7.91997 10.0824 7.72771 9.84811 7.61418 9.57403C7.50065 9.29994 7.47094 8.99834 7.52882 8.70736C7.5867 8.41639 7.72956 8.14912 7.93934 7.93934C8.14912 7.72956 8.41639 7.5867 8.70737 7.52882C8.99834 7.47094 9.29994 7.50065 9.57403 7.61418C9.84811 7.72771 10.0824 7.91997 10.2472 8.16665C10.412 8.41332 10.5 8.70333 10.5 9C10.5 9.39782 10.342 9.77936 10.0607 10.0607C9.77936 10.342 9.39782 10.5 9 10.5ZM4.5 6.75C4.5 6.89834 4.45601 7.04334 4.3736 7.16668C4.29119 7.29001 4.17406 7.38614 4.03701 7.44291C3.89997 7.49968 3.74917 7.51453 3.60368 7.48559C3.4582 7.45665 3.32456 7.38522 3.21967 7.28033C3.11478 7.17544 3.04335 7.0418 3.01441 6.89632C2.98547 6.75083 3.00032 6.60003 3.05709 6.46299C3.11386 6.32594 3.20999 6.20881 3.33332 6.1264C3.45666 6.04399 3.60166 6 3.75 6C3.94891 6 4.13968 6.07902 4.28033 6.21967C4.42098 6.36032 4.5 6.55109 4.5 6.75ZM15 6.75C15 6.89834 14.956 7.04334 14.8736 7.16668C14.7912 7.29001 14.6741 7.38614 14.537 7.44291C14.4 7.49968 14.2492 7.51453 14.1037 7.48559C13.9582 7.45665 13.8246 7.38522 13.7197 7.28033C13.6148 7.17544 13.5434 7.0418 13.5144 6.89632C13.4855 6.75083 13.5003 6.60003 13.5571 6.46299C13.6139 6.32594 13.71 6.20881 13.8333 6.1264C13.9567 6.04399 14.1017 6 14.25 6C14.4489 6 14.6397 6.07902 14.7803 6.21967C14.921 6.36032 15 6.55109 15 6.75ZM4.5 11.25C4.5 11.3983 4.45601 11.5433 4.3736 11.6667C4.29119 11.79 4.17406 11.8861 4.03701 11.9429C3.89997 11.9997 3.74917 12.0145 3.60368 11.9856C3.4582 11.9566 3.32456 11.8852 3.21967 11.7803C3.11478 11.6754 3.04335 11.5418 3.01441 11.3963C2.98547 11.2508 3.00032 11.1 3.05709 10.963C3.11386 10.8259 3.20999 10.7088 3.33332 10.6264C3.45666 10.544 3.60166 10.5 3.75 10.5C3.94891 10.5 4.13968 10.579 4.28033 10.7197C4.42098 10.8603 4.5 11.0511 4.5 11.25ZM15 11.25C15 11.3983 14.956 11.5433 14.8736 11.6667C14.7912 11.79 14.6741 11.8861 14.537 11.9429C14.4 11.9997 14.2492 12.0145 14.1037 11.9856C13.9582 11.9566 13.8246 11.8852 13.7197 11.7803C13.6148 11.6754 13.5434 11.5418 13.5144 11.3963C13.4855 11.2508 13.5003 11.1 13.5571 10.963C13.6139 10.8259 13.71 10.7088 13.8333 10.6264C13.9567 10.544 14.1017 10.5 14.25 10.5C14.4489 10.5 14.6397 10.579 14.7803 10.7197C14.921 10.8603 15 11.0511 15 11.25Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3227_12000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  }))))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "cross_solid_black",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 6L6 18",
    stroke: "#101213",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6L18 18",
    stroke: "#101213",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "cross_rounded_solid_red",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cc092f",
    d: "M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208s208-93.31 208-208S370.69 48 256 48Zm75.31 260.69a16 16 0 1 1-22.62 22.62L256 278.63l-52.69 52.68a16 16 0 0 1-22.62-22.62L233.37 256l-52.68-52.69a16 16 0 0 1 22.62-22.62L256 233.37l52.69-52.68a16 16 0 0 1 22.62 22.62L278.63 256Z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "tick_rounded_solid_green",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.1536,
    cy: 10,
    rx: 10.0218,
    ry: 10,
    fill: "#74b816"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15134 11.5858L13.7573 6.98926L14.4664 7.69626L9.15134 12.9998L5.9624 9.81776L6.67094 9.11076L9.15134 11.5858Z",
    fill: "white"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow_up_blue",
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.170757 9.52142C0.0591506 9.40981 0.00334538 9.28146 0.00334537 9.13637C0.00334536 8.99128 0.0591506 8.86293 0.170757 8.75133L7.9721 0.949984C8.0837 0.838377 8.21205 0.782573 8.35714 0.782573C8.50223 0.782573 8.63058 0.838377 8.74219 0.949984L16.5435 8.75132C16.6551 8.86293 16.7109 8.99128 16.7109 9.13637C16.7109 9.28146 16.6551 9.40981 16.5435 9.52141L15.7065 10.3585C15.5949 10.4701 15.4665 10.5259 15.3214 10.5259C15.1763 10.5259 15.048 10.4701 14.9364 10.3585L8.35714 3.77923L1.7779 10.3585C1.6663 10.4701 1.53795 10.5259 1.39286 10.5259C1.24777 10.5259 1.11942 10.4701 1.00781 10.3585L0.170757 9.52142Z",
    fill: "#005C8A"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow_down_blue",
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8292 1.47859C16.9408 1.59019 16.9966 1.71854 16.9966 1.86363C16.9966 2.00872 16.9408 2.13707 16.8292 2.24868L9.02784 10.05C8.91623 10.1616 8.78789 10.2174 8.6428 10.2174C8.49771 10.2174 8.36936 10.1616 8.25775 10.05L0.456412 2.24868C0.344805 2.13707 0.289001 2.00872 0.289001 1.86363C0.289001 1.71854 0.344805 1.59019 0.456412 1.47859L1.29347 0.641532C1.40507 0.529925 1.53342 0.474121 1.67851 0.474121C1.8236 0.474121 1.95195 0.529925 2.06356 0.641532L8.6428 7.22077L15.222 0.641532C15.3336 0.529925 15.462 0.474121 15.6071 0.474121C15.7522 0.474121 15.8805 0.529925 15.9921 0.641532L16.8292 1.47859Z",
    fill: "#005C8A"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "user_light_gray",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1280_61094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 18.0005H14.25V14.2182C14.2494 13.6302 14.0156 13.0665 13.5998 12.6507C13.184 12.2349 12.6203 12.0011 12.0322 12.0005H5.96775C5.37975 12.0011 4.816 12.2349 4.40022 12.6507C3.98444 13.0665 3.7506 13.6302 3.75 14.2182V18.0005H2.25V14.2182C2.25119 13.2326 2.64326 12.2876 3.34022 11.5907C4.03717 10.8937 4.98211 10.5016 5.96775 10.5005H12.0322C13.0179 10.5016 13.9628 10.8937 14.6598 11.5907C15.3567 12.2876 15.7488 13.2326 15.75 14.2182V18.0005Z",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 8.99996C8.10999 8.99996 7.23996 8.73604 6.49994 8.24157C5.75991 7.7471 5.18314 7.0443 4.84254 6.22203C4.50195 5.39976 4.41283 4.49496 4.58647 3.62205C4.7601 2.74914 5.18869 1.94731 5.81802 1.31798C6.44736 0.688639 7.24918 0.260056 8.1221 0.0864225C8.99501 -0.087211 9.89981 0.00190401 10.7221 0.342498C11.5443 0.683093 12.2471 1.25987 12.7416 1.99989C13.2361 2.73991 13.5 3.60994 13.5 4.49996C13.4988 5.69306 13.0243 6.83697 12.1807 7.68062C11.337 8.52428 10.1931 8.99877 9 8.99996V8.99996ZM9 1.49996C8.40666 1.49996 7.82664 1.6759 7.33329 2.00555C6.83994 2.33519 6.45543 2.80373 6.22836 3.35191C6.0013 3.90008 5.94189 4.50328 6.05765 5.08523C6.1734 5.66717 6.45912 6.20172 6.87868 6.62128C7.29824 7.04083 7.83279 7.32656 8.41473 7.44231C8.99667 7.55807 9.59987 7.49866 10.1481 7.2716C10.6962 7.04453 11.1648 6.66001 11.4944 6.16667C11.8241 5.67332 12 5.0933 12 4.49996C12 3.70431 11.6839 2.94125 11.1213 2.37864C10.5587 1.81603 9.79565 1.49996 9 1.49996Z",
    fill: "#cccccc"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1280_61094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  }))))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "dashboard_light_gray",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1280_61091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.375 14.6252V16.5002H2.25C2.05109 16.5002 1.86032 16.4212 1.71967 16.2806C1.57902 16.1399 1.5 15.9491 1.5 15.7502V14.6252H3.375ZM4.875 13.1252H0V15.7502C0 16.347 0.237053 16.9193 0.65901 17.3412C1.08097 17.7632 1.65326 18.0002 2.25 18.0002H4.875V13.1252Z",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 14.6252V15.7502C16.5 15.9491 16.421 16.1399 16.2803 16.2806C16.1397 16.4212 15.9489 16.5002 15.75 16.5002H14.625V14.6252H16.5ZM18 13.1252H13.125V18.0002H15.75C16.3467 18.0002 16.919 17.7632 17.341 17.3412C17.7629 16.9193 18 16.347 18 15.7502V13.1252Z",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.375 8.06227V9.93726H1.5V8.06227H3.375ZM4.875 6.56227H0V11.4373H4.875V6.56227Z",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.06227V9.93726H14.625V8.06227H16.5ZM18 6.56227H13.125V11.4373H18V6.56227Z",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.375 1.5V3.375H1.5V2.25C1.5 2.05109 1.57902 1.86032 1.71967 1.71967C1.86032 1.57902 2.05109 1.5 2.25 1.5H3.375ZM4.875 0H2.25C1.65326 0 1.08097 0.237053 0.65901 0.65901C0.237053 1.08097 0 1.65326 0 2.25L0 4.875H4.875V0Z",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93749 14.6252V16.5002H8.0625V14.6252H9.93749ZM11.4375 13.1252H6.5625V18.0002H11.4375V13.1252Z",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93749 8.06227V9.93726H8.0625V8.06227H9.93749ZM11.4375 6.56227H6.5625V11.4373H11.4375V6.56227Z",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93749 1.5V3.375H8.0625V1.5H9.93749ZM11.4375 0H6.5625V4.875H11.4375V0Z",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 1.5C15.9489 1.5 16.1397 1.57902 16.2803 1.71967C16.421 1.86032 16.5 2.05109 16.5 2.25V3.375H14.625V1.5H15.75ZM15.75 0H13.125V4.875H18V2.25C18 1.65326 17.7629 1.08097 17.341 0.65901C16.919 0.237053 16.3467 0 15.75 0V0Z",
    fill: "#cccccc"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1280_61091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  }))))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "config_light_gray",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1280_61092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 16H6.0002V13.658C5.30504 13.412 4.66117 13.04 4.10087 12.5607L2.07153 13.7333L0.0715332 10.2667L2.1002 9.09667C1.96694 8.37163 1.96694 7.62837 2.1002 6.90333L0.0715332 5.73333L2.07153 2.26667L4.10087 3.43933C4.66117 2.95995 5.30504 2.58796 6.0002 2.342V0H10.0002V2.342C10.6954 2.58796 11.3392 2.95995 11.8995 3.43933L13.9289 2.26667L15.9289 5.73333L13.9002 6.90333C14.0335 7.62837 14.0335 8.37163 13.9002 9.09667L15.9289 10.2667L13.9289 13.7333L11.8995 12.5613C11.3392 13.0405 10.6953 13.4122 10.0002 13.658V16ZM7.33353 14.6667H8.66687V12.6487L9.16753 12.5193C9.98887 12.3066 10.7365 11.8734 11.3295 11.2667L11.6915 10.898L13.4402 11.908L14.1069 10.7533L12.3602 9.74467L12.4975 9.24733C12.7233 8.42929 12.7233 7.56538 12.4975 6.74733L12.3602 6.25L14.1069 5.24133L13.4402 4.08667L11.6915 5.09933L11.3295 4.73333C10.7361 4.12756 9.98858 3.69535 9.16753 3.48333L8.66687 3.35133V1.33333H7.33353V3.35133L6.83287 3.48067C6.01153 3.69343 5.26394 4.12659 4.67087 4.73333L4.30887 5.102L2.5602 4.08933L1.89353 5.244L3.6402 6.25267L3.50287 6.75C3.2771 7.56804 3.2771 8.43196 3.50287 9.25L3.6402 9.74733L1.89353 10.756L2.5602 11.9107L4.30887 10.9007L4.67087 11.2693C5.26426 11.8751 6.01182 12.3073 6.83287 12.5193L7.33353 12.6487V14.6667ZM8.0002 10.6667C7.47278 10.6667 6.95721 10.5103 6.51868 10.2173C6.08015 9.92424 5.73835 9.50776 5.53652 9.02049C5.33469 8.53322 5.28188 7.99704 5.38477 7.47976C5.48767 6.96248 5.74164 6.48732 6.11458 6.11438C6.48752 5.74144 6.96268 5.48747 7.47996 5.38457C7.99724 5.28168 8.53342 5.33449 9.02069 5.53632C9.50796 5.73815 9.92443 6.07995 10.2175 6.51848C10.5105 6.95701 10.6669 7.47258 10.6669 8C10.6669 8.70724 10.3859 9.38552 9.88582 9.88562C9.38572 10.3857 8.70744 10.6667 8.0002 10.6667ZM8.0002 6.66667C7.73649 6.66667 7.47871 6.74487 7.25944 6.89137C7.04017 7.03788 6.86928 7.24612 6.76836 7.48976C6.66744 7.73339 6.64104 8.00148 6.69249 8.26012C6.74393 8.51876 6.87092 8.75634 7.05739 8.94281C7.24386 9.12928 7.48144 9.25627 7.74008 9.30771C7.99872 9.35916 8.26681 9.33276 8.51044 9.23184C8.75408 9.13092 8.96232 8.96003 9.10883 8.74076C9.25533 8.52149 9.33353 8.26371 9.33353 8C9.33353 7.64638 9.19306 7.30724 8.94301 7.05719C8.69296 6.80714 8.35382 6.66667 8.0002 6.66667Z",
    fill: "#cccccc"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1280_61092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#cccccc"
  }))))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "exclamation_solid_red",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16C6.41775 16 4.87104 15.5308 3.55544 14.6518C2.23985 13.7727 1.21447 12.5233 0.608967 11.0615C0.00346629 9.59966 -0.15496 7.99113 0.153721 6.43928C0.462403 4.88743 1.22433 3.46197 2.34315 2.34315C3.46197 1.22433 4.88743 0.462403 6.43928 0.153721C7.99113 -0.15496 9.59966 0.00346629 11.0615 0.608967C12.5233 1.21447 13.7727 2.23985 14.6518 3.55544C15.5308 4.87104 16 6.41775 16 8C15.9977 10.121 15.1541 12.1545 13.6543 13.6543C12.1545 15.1541 10.121 15.9977 8 16ZM8 1.33334C6.68146 1.33334 5.39253 1.72433 4.2962 2.45687C3.19987 3.18942 2.34539 4.23061 1.84081 5.44878C1.33622 6.66695 1.2042 8.0074 1.46144 9.30061C1.71867 10.5938 2.35361 11.7817 3.28596 12.714C4.21831 13.6464 5.4062 14.2813 6.6994 14.5386C7.99261 14.7958 9.33305 14.6638 10.5512 14.1592C11.7694 13.6546 12.8106 12.8001 13.5431 11.7038C14.2757 10.6075 14.6667 9.31855 14.6667 8C14.6647 6.23249 13.9617 4.53792 12.7119 3.2881C11.4621 2.03828 9.76752 1.33528 8 1.33334Z",
    fill: "#CC092F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66684 3.33313H7.3335V9.9998H8.66684V3.33313Z",
    fill: "#CC092F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66684 11.3331H7.3335V12.6665H8.66684V11.3331Z",
    fill: "#CC092F"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "warning_solid_yellow",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline warning-border",
    d: "M496.1,409.7L290.8,54.1c-15.8-26.4-52.5-27.1-69.6,0L15.9,409.7c-13.9,26,1.1,60.2,34.8,60.2h410.6C491.7,469.9,512,438,496.1,409.7z M83.2,407L256,107.6L428.8,407H83.2z",
    fill: "#eed202"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline warning-stem",
    d: "M284,285v-75c0-38-56-37.5-56,0v75C228,322.5,284,322,284,285z",
    fill: "#eed202"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline warning-dot",
    cx: 256,
    cy: 361.9,
    r: 32,
    fill: "#eed202"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "warning_solid_red",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline warning-border",
    d: "M496.1,409.7L290.8,54.1c-15.8-26.4-52.5-27.1-69.6,0L15.9,409.7c-13.9,26,1.1,60.2,34.8,60.2h410.6C491.7,469.9,512,438,496.1,409.7z M83.2,407L256,107.6L428.8,407H83.2z",
    fill: "#da1313"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline warning-stem",
    d: "M284,285v-75c0-38-56-37.5-56,0v75C228,322.5,284,322,284,285z",
    fill: "#da1313"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline warning-dot",
    cx: 256,
    cy: 361.9,
    r: 32,
    fill: "#da1313"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "filter_solid_blue",
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.0842 12.2206L7.69531 13.0261V7.7175C7.69442 7.50617 7.61052 7.30365 7.4617 7.15361L2.2417 1.86111H14.7761L9.5642 7.15361C9.41538 7.30365 9.33148 7.50617 9.33059 7.7175L9.30642 13.9444L10.9175 14.75V8.04778L16.2181 2.66667C16.4301 2.45156 16.5513 2.16311 16.5564 1.86111V1.05556C16.5564 0.61066 16.1958 0.25 15.7509 0.25H1.25087C0.805972 0.25 0.445312 0.61066 0.445312 1.05556V1.86111C0.450466 2.16311 0.571612 2.45156 0.783646 2.66667L6.0842 8.04778V12.2206Z",
    fill: "#005C8A"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "cross_solid_blue",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 6L6 18",
    stroke: "#005C8A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 6L18 18",
    stroke: "#005C8A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "piechart_light_gray",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1280_61090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0C7.21997 0 5.47991 0.527841 3.99987 1.51677C2.51983 2.50571 1.36628 3.91131 0.685088 5.55585C0.00389957 7.20038 -0.17433 9.00998 0.172937 10.7558C0.520204 12.5016 1.37737 14.1053 2.63604 15.364C3.89472 16.6226 5.49836 17.4798 7.24419 17.8271C8.99002 18.1743 10.7996 17.9961 12.4442 17.3149C14.0887 16.6337 15.4943 15.4802 16.4832 14.0001C17.4722 12.5201 18 10.78 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948212 11.387 0 9 0V0ZM16.4618 8.25H9.75V1.53825C11.4704 1.71342 13.0776 2.47683 14.3004 3.69961C15.5232 4.92239 16.2866 6.52963 16.4618 8.25V8.25ZM1.5 9C1.50235 7.14146 2.19378 5.34981 3.44059 3.97153C4.6874 2.59326 6.401 1.72627 8.25 1.53825V9.3105L13.743 14.8035C12.6449 15.7031 11.3138 16.2723 9.90482 16.4448C8.4958 16.6173 7.06676 16.3861 5.78403 15.7781C4.50131 15.17 3.41766 14.2101 2.65924 13.0102C1.90081 11.8102 1.4988 10.4195 1.5 9V9ZM14.8035 13.743L10.8105 9.75H16.4618C16.3155 11.2156 15.7385 12.605 14.8035 13.743Z",
    fill: "#cccccc"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1280_61090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#cccccc"
  }))))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "histogram_light_gray",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1280_61088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 16.482C2.05109 16.482 1.86032 16.403 1.71967 16.2623C1.57902 16.1217 1.5 15.9309 1.5 15.732V0H0V15.732C0 16.3287 0.237053 16.901 0.65901 17.323C1.08097 17.7449 1.65326 17.982 2.25 17.982H18V16.482H2.25Z",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25 9H3.75V14.25H5.25V9Z",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00001 7.49988H7.5V14.2499H9.00001V7.49988Z",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9.74989H11.25V14.2499H12.75V9.74989Z",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5003 6.75H15.0002V14.25H16.5003V6.75Z",
    fill: "#cccccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24998 3.31063L12 7.06063L17.7802 1.28038L16.7197 0.219879L12 4.93963L8.24998 1.18963L3.96973 5.46988L5.03023 6.53038L8.24998 3.31063Z",
    fill: "#cccccc"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1280_61088"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  }))))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "audit_light_gray",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.8105 0H2.75C2.15326 0 1.58097 0.237053 1.15901 0.65901C0.737053 1.08097 0.5 1.65326 0.5 2.25V18H15.5V5.6895L9.8105 0ZM10.25 2.5605L12.9395 5.25H10.25V2.5605ZM2 16.5V2.25C2 2.05109 2.07902 1.86032 2.21967 1.71967C2.36032 1.57902 2.55109 1.5 2.75 1.5H8.75V6.75H14V16.5H2ZM10.4697 9.8415L11.5302 10.902L8.84075 13.5907C8.63181 13.7997 8.38376 13.9655 8.11075 14.0786C7.83774 14.1917 7.54513 14.2499 7.24962 14.2499C6.95412 14.2499 6.66151 14.1917 6.3885 14.0786C6.11549 13.9655 5.86744 13.7997 5.6585 13.5907L4.46975 12.402L5.53025 11.3415L6.71975 12.5303C6.86252 12.6668 7.05246 12.743 7.25 12.743C7.44754 12.743 7.63747 12.6668 7.78025 12.5303L10.4697 9.8415Z",
    fill: "#cccccc"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "reset_solid_black",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3051_61546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C6.03058 0.00595759 4.13219 0.73636 2.66667 2.052V0H1.33333V3.42867C1.33369 3.7569 1.46423 4.07158 1.69633 4.30368C1.92842 4.53577 2.2431 4.66631 2.57133 4.66667H6V3.33333H3.25267C4.33618 2.23571 5.76721 1.5484 7.30125 1.38882C8.8353 1.22924 10.3772 1.6073 11.6634 2.45841C12.9496 3.30952 13.9004 4.58085 14.3532 6.05519C14.8061 7.52953 14.733 9.11537 14.1463 10.5418C13.5597 11.9682 12.4959 13.1466 11.1368 13.8757C9.77768 14.6048 8.20757 14.8393 6.69472 14.5392C5.18188 14.2391 3.82019 13.423 2.84232 12.2303C1.86445 11.0376 1.33107 9.54232 1.33333 8H0C0 9.58225 0.469192 11.129 1.34824 12.4446C2.22729 13.7602 3.47672 14.7855 4.93853 15.391C6.40034 15.9965 8.00888 16.155 9.56072 15.8463C11.1126 15.5376 12.538 14.7757 13.6569 13.6569C14.7757 12.538 15.5376 11.1126 15.8463 9.56072C16.155 8.00888 15.9965 6.40034 15.391 4.93853C14.7855 3.47672 13.7602 2.22729 12.4446 1.34824C11.129 0.469192 9.58225 0 8 0V0Z",
    fill: "#101213"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3051_61546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "reset_solid_blue",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3051_61546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C6.03058 0.00595759 4.13219 0.73636 2.66667 2.052V0H1.33333V3.42867C1.33369 3.7569 1.46423 4.07158 1.69633 4.30368C1.92842 4.53577 2.2431 4.66631 2.57133 4.66667H6V3.33333H3.25267C4.33618 2.23571 5.76721 1.5484 7.30125 1.38882C8.8353 1.22924 10.3772 1.6073 11.6634 2.45841C12.9496 3.30952 13.9004 4.58085 14.3532 6.05519C14.8061 7.52953 14.733 9.11537 14.1463 10.5418C13.5597 11.9682 12.4959 13.1466 11.1368 13.8757C9.77768 14.6048 8.20757 14.8393 6.69472 14.5392C5.18188 14.2391 3.82019 13.423 2.84232 12.2303C1.86445 11.0376 1.33107 9.54232 1.33333 8H0C0 9.58225 0.469192 11.129 1.34824 12.4446C2.22729 13.7602 3.47672 14.7855 4.93853 15.391C6.40034 15.9965 8.00888 16.155 9.56072 15.8463C11.1126 15.5376 12.538 14.7757 13.6569 13.6569C14.7757 12.538 15.5376 11.1126 15.8463 9.56072C16.155 8.00888 15.9965 6.40034 15.391 4.93853C14.7855 3.47672 13.7602 2.22729 12.4446 1.34824C11.129 0.469192 9.58225 0 8 0V0Z",
    fill: "#005C8A"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3051_61546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "info_solid_blue",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C9.62663 24 7.30655 23.2962 5.33316 21.9776C3.35977 20.6591 1.8217 18.7849 0.913451 16.5922C0.00519943 14.3995 -0.232441 11.9867 0.230582 9.65892C0.693605 7.33114 1.83649 5.19295 3.51472 3.51472C5.19295 1.83649 7.33115 0.693599 9.65892 0.230576C11.9867 -0.232446 14.3995 0.00519371 16.5922 0.913445C18.7849 1.8217 20.6591 3.35977 21.9776 5.33316C23.2962 7.30655 24 9.62662 24 12C23.9966 15.1815 22.7312 18.2318 20.4815 20.4815C18.2318 22.7312 15.1815 23.9966 12 24V24ZM12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C21.9971 9.34873 20.9426 6.80688 19.0679 4.93215C17.1931 3.05741 14.6513 2.00291 12 2V2Z",
    fill: "#005C8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9998 19.0003H11.9998V12.0003H9.99985V10.0003H11.9998C12.5303 10.0003 13.039 10.211 13.4141 10.5861C13.7891 10.9612 13.9998 11.4699 13.9998 12.0003V19.0003Z",
    fill: "#005C8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.99969C12.8284 7.99969 13.5 7.32811 13.5 6.49969C13.5 5.67126 12.8284 4.99969 12 4.99969C11.1716 4.99969 10.5 5.67126 10.5 6.49969C10.5 7.32811 11.1716 7.99969 12 7.99969Z",
    fill: "#005C8A"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "override_user_solid_blue",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3051_61537)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 9H12V7.5H18V9ZM11.2305 4.5C11.2305 3.60999 10.9666 2.73996 10.4721 1.99994C9.97765 1.25991 9.27484 0.683138 8.45258 0.342544C7.63031 0.00194979 6.72551 -0.0871652 5.85259 0.0864683C4.97968 0.260102 4.17786 0.688685 3.54852 1.31802C2.91918 1.94736 2.4906 2.74918 2.31697 3.6221C2.14333 4.49501 2.23245 5.39981 2.57304 6.22208C2.91364 7.04435 3.49041 7.74715 4.23043 8.24162C4.97046 8.73608 5.84048 9 6.7305 9C7.92361 8.99881 9.06751 8.52432 9.91116 7.68067C10.7548 6.83701 11.2293 5.69311 11.2305 4.5V4.5ZM9.7305 4.5C9.7305 5.09335 9.55455 5.67337 9.22491 6.16671C8.89526 6.66006 8.42673 7.04458 7.87855 7.27164C7.33037 7.4987 6.72717 7.55811 6.14523 7.44236C5.56329 7.3266 5.02874 7.04088 4.60918 6.62132C4.18962 6.20177 3.9039 5.66722 3.78814 5.08527C3.67239 4.50333 3.7318 3.90013 3.95886 3.35195C4.18592 2.80377 4.57044 2.33524 5.06379 2.00559C5.55714 1.67595 6.13716 1.5 6.7305 1.5C7.52615 1.5 8.28921 1.81607 8.85182 2.37868C9.41443 2.94129 9.7305 3.70435 9.7305 4.5ZM13.5 14.25C13.4988 13.2558 13.1033 12.3027 12.4003 11.5997C11.6973 10.8967 10.7442 10.5012 9.75 10.5H3.75C2.7558 10.5012 1.80267 10.8967 1.09966 11.5997C0.396661 12.3027 0.00119089 13.2558 0 14.25L0 18H1.5V14.25C1.5 13.6533 1.73705 13.081 2.15901 12.659C2.58097 12.2371 3.15326 12 3.75 12H9.75C10.3467 12 10.919 12.2371 11.341 12.659C11.7629 13.081 12 13.6533 12 14.25V18H13.5V14.25Z",
    fill: "#005C8A"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3051_61537"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  }))))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "contractor_edit_solid_blue",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3051_61533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 12.6665H6.27616L15.3715 3.57117C15.7611 3.18062 15.9799 2.65149 15.9799 2.09984C15.9799 1.54819 15.7611 1.01906 15.3715 0.628507C14.9753 0.249769 14.4483 0.0384064 13.9002 0.0384064C13.352 0.0384064 12.825 0.249769 12.4288 0.628507L3.3335 9.72384V12.6665ZM4.66683 10.2758L13.3715 1.57117C13.5139 1.43514 13.7032 1.35924 13.9002 1.35924C14.0971 1.35924 14.2864 1.43514 14.4288 1.57117C14.5688 1.71152 14.6474 1.90163 14.6474 2.09984C14.6474 2.29805 14.5688 2.48816 14.4288 2.62851L5.72416 11.3332H4.66683V10.2758Z",
    fill: "#005C8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7473 5.08133L14.6667 6.162V10.6667H10.6667V14.6667H1.33333V2C1.33333 1.82319 1.40357 1.65362 1.5286 1.5286C1.65362 1.40357 1.82319 1.33333 2 1.33333H9.83867L10.9193 0.252667C11.0167 0.162416 11.1193 0.0780441 11.2267 0L2 0C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2L0 16H12.276L16 12.276V4.774C15.9218 4.88124 15.8374 4.98386 15.7473 5.08133V5.08133ZM12 14.3907V12H14.3907L12 14.3907Z",
    fill: "#005C8A"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3051_61533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "eye_blue",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3ZM12.0003 19C16.2359 19 19.8603 16.052 20.7777 12C19.8603 7.94803 16.2359 5 12.0003 5C7.7646 5 4.14022 7.94803 3.22278 12C4.14022 16.052 7.7646 19 12.0003 19ZM12.0003 16.5C9.51498 16.5 7.50026 14.4853 7.50026 12C7.50026 9.51472 9.51498 7.5 12.0003 7.5C14.4855 7.5 16.5003 9.51472 16.5003 12C16.5003 14.4853 14.4855 16.5 12.0003 16.5ZM12.0003 14.5C13.381 14.5 14.5003 13.3807 14.5003 12C14.5003 10.6193 13.381 9.5 12.0003 9.5C10.6196 9.5 9.50026 10.6193 9.50026 12C9.50026 13.3807 10.6196 14.5 12.0003 14.5Z",
    fill: "#005C8A"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "settings_slider_solid_blue",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.931 2.75032C10.7164 1.96059 10.2478 1.26343 9.59767 0.766389C8.94752 0.269352 8.15188 6.10352e-05 7.3335 6.10352e-05C6.51512 6.10352e-05 5.71948 0.269352 5.06933 0.766389C4.41917 1.26343 3.95064 1.96059 3.736 2.75032H0V4.75032H3.736C3.95064 5.54005 4.41917 6.23721 5.06933 6.73425C5.71948 7.23129 6.51512 7.50058 7.3335 7.50058C8.15188 7.50058 8.94752 7.23129 9.59767 6.73425C10.2478 6.23721 10.7164 5.54005 10.931 4.75032H24V2.75032H10.931ZM7.333 5.50032C6.98688 5.50032 6.64854 5.39768 6.36075 5.20539C6.07297 5.0131 5.84866 4.73979 5.71621 4.42002C5.58376 4.10025 5.5491 3.74838 5.61663 3.40891C5.68415 3.06945 5.85082 2.75763 6.09556 2.51288C6.3403 2.26814 6.65213 2.10147 6.99159 2.03395C7.33106 1.96642 7.68293 2.00108 8.0027 2.13353C8.32247 2.26598 8.59578 2.49029 8.78807 2.77807C8.98036 3.06586 9.083 3.4042 9.083 3.75032C9.08221 4.21421 8.89758 4.65886 8.56956 4.98688C8.24154 5.3149 7.79689 5.49953 7.333 5.50032V5.50032Z",
    fill: "#005C8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.667 8.25C15.8495 8.25293 15.0553 8.5233 14.4058 9.01985C13.7564 9.51639 13.2872 10.2118 13.07 11H0V13H13.07C13.2843 13.7899 13.7526 14.4873 14.4027 14.9846C15.0528 15.4818 15.8485 15.7512 16.667 15.7512C17.4855 15.7512 18.2812 15.4818 18.9313 14.9846C19.5814 14.4873 20.0497 13.7899 20.264 13H24V11H20.264C20.0468 10.2118 19.5776 9.51639 18.9282 9.01985C18.2787 8.5233 17.4845 8.25293 16.667 8.25V8.25ZM16.667 13.75C16.3209 13.75 15.9825 13.6474 15.6948 13.4551C15.407 13.2628 15.1827 12.9895 15.0502 12.6697C14.9178 12.3499 14.8831 11.9981 14.9506 11.6586C15.0181 11.3191 15.1848 11.0073 15.4296 10.7626C15.6743 10.5178 15.9861 10.3511 16.3256 10.2836C16.6651 10.2161 17.0169 10.2508 17.3367 10.3832C17.6565 10.5157 17.9298 10.74 18.1221 11.0278C18.3144 11.3155 18.417 11.6539 18.417 12C18.4165 12.464 18.2319 12.9088 17.9039 13.2369C17.5758 13.5649 17.131 13.7495 16.667 13.75V13.75Z",
    fill: "#005C8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.333 16.5C6.51494 16.5023 5.72013 16.7723 5.07004 17.2689C4.41995 17.7655 3.95035 18.4613 3.733 19.25H0V21.25H3.736C3.95064 22.0397 4.41917 22.7369 5.06933 23.2339C5.71948 23.731 6.51512 24.0002 7.3335 24.0002C8.15188 24.0002 8.94752 23.731 9.59767 23.2339C10.2478 22.7369 10.7164 22.0397 10.931 21.25H24V19.25H10.931C10.7137 18.4617 10.2444 17.7661 9.59476 17.2695C8.94507 16.773 8.15072 16.5027 7.333 16.5ZM7.333 22C6.98688 22 6.64854 21.8974 6.36075 21.7051C6.07297 21.5128 5.84866 21.2395 5.71621 20.9197C5.58376 20.5999 5.5491 20.2481 5.61663 19.9086C5.68415 19.5691 5.85082 19.2573 6.09556 19.0126C6.3403 18.7678 6.65213 18.6011 6.99159 18.5336C7.33106 18.4661 7.68293 18.5008 8.0027 18.6332C8.32247 18.7657 8.59578 18.99 8.78807 19.2777C8.98036 19.5655 9.083 19.9039 9.083 20.25C9.08221 20.7139 8.89758 21.1585 8.56956 21.4866C8.24154 21.8146 7.79689 21.9992 7.333 22V22Z",
    fill: "#005C8A"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "timeline-icon-rejected",
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1681_62251)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 11.3999,
    r: 8,
    stroke: "#DC2020"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1681_62251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0003 6.06641C17.9455 6.06641 16.9143 6.3792 16.0373 6.96523C15.1602 7.55127 14.4766 8.38422 14.073 9.35876C13.6693 10.3333 13.5637 11.4057 13.7695 12.4402C13.9753 13.4748 14.4832 14.4251 15.2291 15.171C15.975 15.9169 16.9253 16.4248 17.9598 16.6306C18.9944 16.8364 20.0668 16.7308 21.0413 16.3271C22.0158 15.9234 22.8488 15.2398 23.4348 14.3628C24.0209 13.4857 24.3337 12.4546 24.3337 11.3997C24.3337 9.98525 23.7718 8.6287 22.7716 7.6285C21.7714 6.62831 20.4148 6.06641 19.0003 6.06641ZM19.0003 15.8442C18.1213 15.8442 17.262 15.5835 16.5311 15.0952C15.8002 14.6068 15.2306 13.9127 14.8942 13.1006C14.5578 12.2884 14.4698 11.3948 14.6413 10.5327C14.8128 9.67053 15.2361 8.87861 15.8576 8.25704C16.4792 7.63548 17.2711 7.21218 18.1333 7.04069C18.9954 6.8692 19.889 6.95722 20.7011 7.29361C21.5133 7.63 22.2074 8.19965 22.6957 8.93054C23.1841 9.66142 23.4448 10.5207 23.4448 11.3997C23.4448 11.9834 23.3298 12.5613 23.1065 13.1006C22.8831 13.6398 22.5557 14.1297 22.143 14.5424C21.7303 14.9551 21.2404 15.2825 20.7011 15.5059C20.1619 15.7292 19.584 15.8442 19.0003 15.8442Z",
    fill: "#DC2020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9997 12.3198C18.8464 12.3198 18.6995 12.2589 18.5911 12.1506C18.4827 12.0422 18.4219 11.8952 18.4219 11.742V9.07534C18.4219 8.9221 18.4827 8.77514 18.5911 8.66679C18.6995 8.55843 18.8464 8.49756 18.9997 8.49756C19.1529 8.49756 19.2998 8.55843 19.4082 8.66679C19.5166 8.77514 19.5774 8.9221 19.5774 9.07534V11.742C19.5774 11.8952 19.5166 12.0422 19.4082 12.1506C19.2998 12.2589 19.1529 12.3198 18.9997 12.3198Z",
    fill: "#DC2020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9782 14.2977C19.3464 14.2977 19.6449 13.9992 19.6449 13.631C19.6449 13.2628 19.3464 12.9644 18.9782 12.9644C18.61 12.9644 18.3115 13.2628 18.3115 13.631C18.3115 13.9992 18.61 14.2977 18.9782 14.2977Z",
    fill: "#DC2020"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1681_62251",
    x: 0.5,
    y: 0.899902,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1681_62251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1681_62251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1681_62251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(11 3.3999)"
  }))))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "timeline-icon-approved",
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1681_62185)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 11.3999,
    r: 8,
    stroke: "#74B816"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1681_62185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7498 13.0895L22.1968 9.64209L22.7274 10.1723L18.7498 14.15L16.3633 11.7635L16.8935 11.2332L18.7498 13.0895Z",
    fill: "#74B816"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1681_62185",
    x: 0.5,
    y: 0.899902,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1681_62185"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1681_62185",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1681_62185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(15 7.3999)"
  }))))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "timeline-icon-in-progress",
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1681_62179)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 11.3999,
    r: 8,
    stroke: "#F59F00"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1681_62179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 11.3999C23 12.4608 22.5786 13.4782 21.8284 14.2283C21.0783 14.9785 20.0609 15.3999 19 15.3999C17.9391 15.3999 16.9217 14.9785 16.1716 14.2283C15.4214 13.4782 15 12.4608 15 11.3999C15 11.2776 15.0057 11.1562 15.0163 11.0366L15.6803 11.0969C15.6712 11.1967 15.6667 11.2977 15.6667 11.3999C15.6667 12.0592 15.8622 12.7036 16.2284 13.2518C16.5947 13.8 17.1153 14.2272 17.7244 14.4795C18.3335 14.7318 19.0037 14.7978 19.6503 14.6692C20.2969 14.5406 20.8908 14.2231 21.357 13.7569C21.8232 13.2908 22.1407 12.6968 22.2693 12.0502C22.3979 11.4036 22.3319 10.7334 22.0796 10.1243C21.8273 9.5152 21.4001 8.99461 20.8519 8.62834C20.3037 8.26207 19.6593 8.06657 19 8.06657C18.8978 8.06657 18.7968 8.07112 18.697 8.08024L18.6367 7.41624C18.7563 7.40557 18.8777 7.3999 19 7.3999C20.0605 7.40105 21.0773 7.82285 21.8272 8.57274C22.5771 9.32264 22.9989 10.3394 23 11.3999ZM16.8877 8.8209L16.465 8.30557C16.2604 8.47377 16.0728 8.66167 15.905 8.86657L16.4207 9.28824C16.5607 9.11759 16.7171 8.96106 16.8877 8.8209ZM18.0473 8.2049L17.857 7.56657C17.6032 7.64202 17.3576 7.74251 17.1237 7.86657L17.4367 8.45524C17.6314 8.3517 17.836 8.26784 18.0473 8.2049ZM16.0547 9.83824L15.4667 9.5249C15.3427 9.75883 15.2422 10.0045 15.1667 10.2582L15.8057 10.4486C15.8682 10.2371 15.9516 10.0325 16.0547 9.83757V9.83824ZM18.6667 9.3999V10.8256C18.5668 10.8837 18.4838 10.9667 18.4257 11.0666H17.3333V11.7332H18.4257C18.4766 11.8216 18.5471 11.8971 18.6319 11.9539C18.7167 12.0107 18.8134 12.0471 18.9145 12.0605C19.0157 12.0739 19.1185 12.0638 19.2151 12.031C19.3118 11.9983 19.3995 11.9437 19.4717 11.8716C19.5438 11.7994 19.5984 11.7117 19.6311 11.615C19.6639 11.5184 19.674 11.4156 19.6606 11.3144C19.6472 11.2133 19.6108 11.1166 19.554 11.0318C19.4972 10.947 19.4217 10.8765 19.3333 10.8256V9.3999H18.6667Z",
    fill: "#F59F00"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1681_62179",
    x: 0.5,
    y: 0.899902,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1681_62179"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1681_62179",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1681_62179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(15 7.3999)"
  }))))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "timeline-icon-not-started",
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1681_62182)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 11.3999,
    r: 8,
    stroke: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1681_62182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 11.3999C23 12.4608 22.5786 13.4782 21.8284 14.2283C21.0783 14.9785 20.0609 15.3999 19 15.3999C17.9391 15.3999 16.9217 14.9785 16.1716 14.2283C15.4214 13.4782 15 12.4608 15 11.3999C15 11.2776 15.0057 11.1562 15.0163 11.0366L15.6803 11.0969C15.6712 11.1967 15.6667 11.2977 15.6667 11.3999C15.6667 12.0592 15.8622 12.7036 16.2284 13.2518C16.5947 13.8 17.1153 14.2272 17.7244 14.4795C18.3335 14.7318 19.0037 14.7978 19.6503 14.6692C20.2969 14.5406 20.8908 14.2231 21.357 13.7569C21.8232 13.2908 22.1407 12.6968 22.2693 12.0502C22.3979 11.4036 22.3319 10.7334 22.0796 10.1243C21.8273 9.5152 21.4001 8.99461 20.8519 8.62834C20.3037 8.26207 19.6593 8.06657 19 8.06657C18.8978 8.06657 18.7968 8.07112 18.697 8.08024L18.6367 7.41624C18.7563 7.40557 18.8777 7.3999 19 7.3999C20.0605 7.40105 21.0773 7.82285 21.8272 8.57274C22.5771 9.32264 22.9989 10.3394 23 11.3999ZM16.8877 8.8209L16.465 8.30557C16.2604 8.47377 16.0728 8.66167 15.905 8.86657L16.4207 9.28824C16.5607 9.11759 16.7171 8.96106 16.8877 8.8209ZM18.0473 8.2049L17.857 7.56657C17.6032 7.64202 17.3576 7.74251 17.1237 7.86657L17.4367 8.45524C17.6314 8.3517 17.836 8.26784 18.0473 8.2049ZM16.0547 9.83824L15.4667 9.5249C15.3427 9.75883 15.2422 10.0045 15.1667 10.2582L15.8057 10.4486C15.8682 10.2371 15.9516 10.0325 16.0547 9.83757V9.83824ZM18.6667 9.3999V10.8256C18.5668 10.8837 18.4838 10.9667 18.4257 11.0666H17.3333V11.7332H18.4257C18.4766 11.8216 18.5471 11.8971 18.6319 11.9539C18.7167 12.0107 18.8134 12.0471 18.9145 12.0605C19.0157 12.0739 19.1185 12.0638 19.2151 12.031C19.3118 11.9983 19.3995 11.9437 19.4717 11.8716C19.5438 11.7994 19.5984 11.7117 19.6311 11.615C19.6639 11.5184 19.674 11.4156 19.6606 11.3144C19.6472 11.2133 19.6108 11.1166 19.554 11.0318C19.4972 10.947 19.4217 10.8765 19.3333 10.8256V9.3999H18.6667Z",
    fill: "#ADB5BD"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1681_62182",
    x: 0.5,
    y: 0.899902,
    width: 37,
    height: 37,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1681_62182"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1681_62182",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1681_62182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(15 7.3999)"
  }))))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "blue_fill_new_tab",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 6V8H5V19H16V14H18V20C18 20.5523 17.5523 21 17 21H4C3.44772 21 3 20.5523 3 20V7C3 6.44772 3.44772 6 4 6H10ZM21 3V11H19L18.9999 6.413L11.2071 14.2071L9.79289 12.7929L17.5849 5H13V3H21Z",
    fill: "rgba(0,92,138,1)"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    id: "blue_fill_edit_details",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_472_44778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 12.6667H6.27616L15.3715 3.57134C15.7611 3.18079 15.9799 2.65166 15.9799 2.10001C15.9799 1.54836 15.7611 1.01923 15.3715 0.628674C14.9753 0.249937 14.4483 0.0385742 13.9002 0.0385742C13.352 0.0385742 12.825 0.249937 12.4288 0.628674L3.3335 9.72401V12.6667ZM4.66683 10.276L13.3715 1.57134C13.5139 1.43531 13.7032 1.3594 13.9002 1.3594C14.0971 1.3594 14.2864 1.43531 14.4288 1.57134C14.5688 1.71168 14.6474 1.9018 14.6474 2.10001C14.6474 2.29821 14.5688 2.48833 14.4288 2.62867L5.72416 11.3333H4.66683V10.276Z",
    fill: "#005C8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7473 5.08133L14.6667 6.162V10.6667H10.6667V14.6667H1.33333V2C1.33333 1.82319 1.40357 1.65362 1.5286 1.5286C1.65362 1.40357 1.82319 1.33333 2 1.33333H9.83867L10.9193 0.252667C11.0167 0.162416 11.1193 0.0780441 11.2267 0L2 0C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2L0 16H12.276L16 12.276V4.774C15.9218 4.88124 15.8374 4.98386 15.7473 5.08133ZM12 14.3907V12H14.3907L12 14.3907Z",
    fill: "#005C8A"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_472_44778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "message_solid_blue",
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 13C19 13.5304 18.7893 14.0391 18.4142 14.4142C18.0391 14.7893 17.5304 15 17 15H5L1 19V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H17C17.5304 1 18.0391 1.21071 18.4142 1.58579C18.7893 1.96086 19 2.46957 19 3V13Z",
    stroke: "#005C8A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpriteIcons);
export default __webpack_public_path__ + "static/media/sprite-icons.3a0c4095141fbc636350b42ea91d5374.svg";
export { ForwardRef as ReactComponent };